import {
	OnBeforeCaptureResponder,
	OnBeforeDragStartResponder, OnDragEndResponder,
	OnDragStartResponder,
	OnDragUpdateResponder,
} from 'react-beautiful-dnd';
import {CurrentItemInfo} from './drag-drop-manager';



export class Subscriber {
	callback: any;
	eventType: EventType;
}

export enum EventType {
	BeforeCapture,
	BeforeDragStart,
	DragStart,
	DragUpdate,
	DragEnd
}


export interface IDragDropManager {
	getCurrentItemInfo(): CurrentItemInfo | null;

	onBeforeCapture(callback: OnBeforeCaptureResponder): Subscriber;
	onBeforeDragStart(callback: OnBeforeDragStartResponder): Subscriber;
	onDragStart(callback: OnDragStartResponder): Subscriber;
	onDragUpdate(callback: OnDragUpdateResponder): Subscriber;
	onDragEnd(callback: OnDragEndResponder): Subscriber;
	unsubscribe(subscriber: Subscriber): void;
}
